import { useState } from "react";
import { useSelector } from "@tanstack/react-store";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { useDataGridContext } from "../DataGridContext";
import styles from "./Grid.module.scss";

/**
 * The validation message of an invalid cell: open while the cell is active
 * and focus is in the grid, and on hover. The anchor covers the cell so the
 * tooltip sits under it.
 */
export const InvalidCellTooltip = ({
    message,
    isActive,
}: {
    message: string;
    isActive: boolean;
}) => {
    const { controller } = useDataGridContext();
    const isFocusWithin = useSelector(controller.isFocusWithin);
    const [isHovered, setIsHovered] = useState(false);
    return (
        <Tooltip
            content={message}
            open={(isActive && isFocusWithin) || isHovered}
            onOpenChange={setIsHovered}
            side="bottom"
        >
            <span className={styles.invalidAnchor} aria-hidden />
        </Tooltip>
    );
};
